import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { proposalService } from '@/services/ProposalService'
import { proposalKeys } from '@/hooks/queryKeys'
import type { ProposalDetailDto } from '@lib/dto/proposal.dto'

/** Load one proposal with every version, newest first. */
export function useProposal(id: string): UseQueryResult<ProposalDetailDto> {
  return useQuery({
    queryKey: proposalKeys.detail(id),
    queryFn: () => proposalService.get(id),
    enabled: id !== '',
    staleTime: 15_000,
  })
}
